import { OfficeHoursPresenter } from '@/forms/components/presenters/OfficeHoursPresenter';
import {
  FormFieldType,
  type FileFormField,
  type OfficeHoursFormField,
  type SingleFormField,
} from '@/forms/typings';

import type { FormFieldModule } from '../registry/field-module.types';

import { buildOfficeHoursInitialState } from './initialState';

export const officeHoursFieldModule: FormFieldModule = {
  type: FormFieldType.OfficeHours,
  Presenter: ({ field, disabled }) => (
    <OfficeHoursPresenter field={field as OfficeHoursFormField} disabled={disabled} />
  ),
  flattenLeaves: field => {
    const f = field as OfficeHoursFormField;
    const dayFields: Array<SingleFormField | FileFormField> = [];
    for (const day of Object.values(f.days)) {
      dayFields.push(...(day.fields as Array<SingleFormField | FileFormField>));
    }
    return dayFields;
  },
  buildInitialState: buildOfficeHoursInitialState,
};
